import { type JSX } from 'react';

import { Anmeldehuelle, type Zustand } from './anmeldung/Anmeldehuelle';
import { Arbeitsflaeche } from './Arbeitsflaeche';
import { TRAINERADRESSE } from './adressen';

/** Der Seitentitel je Maske — er sagt Hilfsmitteln, wo man gelandet ist. */
const TITEL: Record<Zustand['art'], string> = {
  pruefe: 'Anmeldung wird geprüft — CRM und Tagesplanung',
  anmeldung: 'Anmeldung — CRM und Tagesplanung',
  faktor: 'Zweiten Faktor einrichten — CRM und Tagesplanung',
  wechsel: 'Passwort vergeben — CRM und Tagesplanung',
  angemeldet: 'Übersicht — CRM und Tagesplanung',
};

/**
 * Einstiegspunkt der CRM-Oberfläche (`index.html`).
 *
 * Die Masken folgen den Fachmodulen der API. Gebaut ist die Anmeldung nach
 * Kapitel 15 — Passwort, zweiter Faktor, erzwungener Wechsel,
 * Sitzungsübersicht —, dazu Kundenakte, Angebotseditor, Faktura und Tagesplan
 * in der Reihenfolge aus Kapitel 25.
 *
 * ============================================================================
 * DER WEG HINEIN LIEGT IN DER ANMELDEHÜLLE
 * ============================================================================
 *
 * Sie gehört beiden Oberflächen — dem CRM und dem Trainerbereich unter
 * `trainer.html`. Hier bleibt nur, was das CRM ausmacht: seine Seitentitel und
 * die Arbeitsfläche.
 */
export function App(): JSX.Element {
  return (
    <Anmeldehuelle
      titel={TITEL}
      angemeldet={(benutzer, abmelden) => {
        /*
         * ====================================================================
         * EIN DIENSTLEISTERKONTO GEHÖRT NICHT HIERHER (RES-30, RES-32)
         * ====================================================================
         *
         * RES-30: „Kundendaten, Preise und eine CRM-Navigation erscheinen
         * nicht." Der Trainerbereich steht unter seiner eigenen Adresse und
         * trägt sein eigenes Bündel; hier wird er NICHT zweitverwendet.
         *
         * Der Grund ist nicht Ordnungsliebe. Wer die Maske auch hier zeigte,
         * hätte zwei Wege zu derselben Oberfläche: einen mit dem kleinen
         * Bündel und einen, der dem Externen den gesamten CRM-Code auf das
         * Telefon lädt. Der zweite Weg wäre der, den niemand prüft.
         *
         * Abgewiesen wird mit dem Verweis und nicht mit einem Fehler: Der
         * Trainer hat sich richtig angemeldet, er steht nur an der falschen
         * Tür. Die Sitzung bleibt deshalb stehen — drüben gilt sie weiter, und
         * ein zweites Anmelden wäre eine Schikane ohne Gewinn.
         */
        if (benutzer.kontoart === 'trainer') {
          return (
            <main className="maske">
              <h1 tabIndex={-1}>Ihr Zugang liegt woanders</h1>
              <p>
                Guten Tag, {benutzer.name}. Ihre Einsätze stehen im Trainerbereich — dieser
                Zugang hier ist die Arbeitsoberfläche des Hauses.
              </p>
              <p>
                <a className="knopf knopf--haupt" href={TRAINERADRESSE}>
                  Zum Trainerbereich
                </a>
              </p>
              <p className="hinweiszeile">
                Merken Sie sich die Adresse {TRAINERADRESSE} — dort sind Sie bereits
                angemeldet.
              </p>
              <p>
                <button type="button" className="knopf knopf--klein" onClick={abmelden}>
                  Abmelden
                </button>
              </p>
            </main>
          );
        }

        // Ab hier gilt das Seitenraster nach Abschnitt 2.3 des Pflichtenhefts:
        // Kopfzeile, Menüzeile, Seitenkopf, Inhalt (i.d.F. ÄA-41). Den Fokus auf die
        // Ueberschrift setzt der Rahmen selbst, weil er beim Maskenwechsel
        // stehen bleibt und nur der Titel wechselt.
        return <Arbeitsflaeche benutzer={benutzer} beiAbmelden={abmelden} />;
      }}
    />
  );
}
